$effects